import React from 'react';
import { StethoscopeIcon, LayersIcon, BoneIcon, FileTextIcon, PrinterIcon, FolderOpenIcon, ClockIcon } from 'lucide-react';
import { benefits } from '../data/content';
const icons = [{
  Icon: StethoscopeIcon,
  color: 'text-brand'
}, {
  Icon: LayersIcon,
  color: 'text-goldDark'
}, {
  Icon: BoneIcon,
  color: 'text-navy'
}, {
  Icon: FileTextIcon,
  color: 'text-brand'
}, {
  Icon: PrinterIcon,
  color: 'text-goldDark'
}, {
  Icon: FolderOpenIcon,
  color: 'text-navy'
}, {
  Icon: ClockIcon,
  color: 'text-check'
}];
export function BenefitsGrid() {
  return <section className="bg-pale px-4 py-6 text-center md:px-12 md:py-8" data-id="element-7" data-mp="evz8qmzbomlh">
      <h2 className="mx-auto max-w-[620px] font-heading text-[21px] font-extrabold uppercase leading-[1.15] tracking-[-0.3px] text-navy md:text-[26px]" data-id="element-8" data-mp="9z8qbt01peww">
        This is not another orthopedic book filled with basic theory.
      </h2>
      <p className="mx-auto mt-1.5 max-w-[620px] font-heading text-[13px] font-bold uppercase leading-tight text-brand md:text-[16px]" data-id="element-9" data-mp="3s4c19ucp0l58">
        It's an organized collection of practical professional resources.
      </p>
      <div className="mt-3 grid gap-2 text-left sm:grid-cols-2" data-id="element-10" data-mp="2bio57j0an8la">
        {benefits.map((b, i) => {
        const {
          Icon,
          color
        } = icons[i % icons.length];
        const isLastOdd = i === benefits.length - 1 && benefits.length % 2 === 1;
        return <article key={b.title} className={`flex gap-2.5 rounded-md border border-line bg-white p-3 ${isLastOdd ? 'sm:col-span-2' : ''}`} data-id="element-11" data-mp="21q096qh518nm" data-mpi={i}>
              <Icon className={`mt-0.5 h-[18px] w-[18px] shrink-0 ${color}`} strokeWidth={2.5} aria-hidden data-id="element-12" data-mp="2ug8tooz5c55d" />
              <div data-id="element-13" data-mp="2gjbspupbd7ar">
                <h3 className="font-heading text-[14px] font-bold leading-tight text-navy md:text-[15px]" data-id="element-14" data-mp="2kiud8pd83gd2">{b.title}</h3>
                <p className="mt-1 text-[13px] leading-[1.4] text-ink md:text-[14px]" data-id="element-15" data-mp="151kfqjawqf58">{b.text}</p>
              </div>
            </article>;
      })}
      </div>
      <p className="mt-3.5 font-heading text-[13px] font-extrabold uppercase leading-tight text-goldDark md:text-[15px]" data-id="element-16" data-mp="191clypctw97f">
        One collection. Six clinical areas. Five professional bonuses.
      </p>
    </section>;
}